import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { FormField } from '../../../components/app';
import { BalanceCheckDialogProps } from '../types';

/** Фактический остаток: единственный способ поймать забытый расход. */
export function BalanceCheckDialog({
  isOpen,
  onOpenChange,
  formData,
  onFormDataChange,
  onSubmit,
  isSubmitting,
}: BalanceCheckDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl p-0">
        <DialogHeader bordered>
          <DialogTitle>Остаток по выписке</DialogTitle>
          <DialogDescription>
            Сколько денег реально на счету на эту дату. Расхождение с Кассой означает забытый Расход или Движение.
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          <div className="grid gap-4 sm:grid-cols-2">
            <FormField label="Дата выписки" required>
              <Input
                type="date"
                value={formData.date}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, date: e.target.value }))}
              />
            </FormField>
            <FormField label="Остаток, сум" required>
              <Input
                type="number"
                step="0.01"
                min="0"
                inputMode="decimal"
                value={formData.amount || ''}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, amount: parseFloat(e.target.value) || 0 }))}
              />
            </FormField>
          </div>

          <FormField label="Комментарий">
            <Input
              type="text"
              placeholder="Например: выписка Kapitalbank"
              value={formData.comment || ''}
              onChange={(e) => onFormDataChange((prev) => ({ ...prev, comment: e.target.value }))}
            />
          </FormField>
        </DialogBody>

        <DialogFooter bordered>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Закрыть
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="animate-spin" />}
            Записать
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
